import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SentView from './SentView';
import { Tabs, PageTitle, Pagination } from 'src/components/App';
import { sentTabs } from '../../config';
import {
  clearTaskReplies,
  fetchSent,
  fetchTaskReplies,
  deleteTaskReply,
} from '../../actions/taskActions';
import { clearContactData } from 'src/modules/contacts/actions/contactActions';
import { Typography } from '@mui/material';
// import { TablePagination } from 'mui-datatables';

export const InboxContainer = (props) => {
  const [currentTab, setCurrentTab] = useState('sent');

  const handlePageChange = ({ page, perPage }) => {
    props.fetchSent(props.sent.filters, { pageNo: page, perPage });
  };

  const paging = props.sent.paging;

  useEffect(() => {
    props.clearTaskReplies();
    props.clearContactData();
    return () => {
      props.clearTaskReplies();
      props.clearContactData();
    };
  }, []);

  return (
    <>
      <PageTitle title="Inbox" />
      <Tabs
        tabs={sentTabs}
        value={currentTab}
        onChange={() => {}}
        justifyContent="space-between"
        customRender={() => (
          <Pagination
            count={paging.count}
            page={paging.pageNo}
            onChange={handlePageChange}
            perPage={paging.perPage}
          />
        )}
      />
      <SentView {...props} />
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.tasks.loading,
  sent: state.tasks.sent,
  taskReplies: state.tasks.taskReplies,
  contact: state.contacts.contact,
  contactLoading: state.contacts.loading.contact,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  clearTaskReplies: () => dispatch(clearTaskReplies()),
  clearContactData: () => dispatch(clearContactData()),
  fetchSent: (filters, paging) => dispatch(fetchSent(filters, paging)),
  fetchTaskReplies: (taskId) => dispatch(fetchTaskReplies(taskId)),
  deleteTaskReply: (replyId) => {
    return new Promise((resolve, reject) => {
      dispatch(deleteTaskReply(replyId, resolve, reject));
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(InboxContainer);
